import { createContext, useContext } from 'react';
export const TopOffsetContext = /*#__PURE__*/ createContext();
export const useTopOffset = ()=>useContext(TopOffsetContext);
